module.exports = __webpack_public_path__ + "static/fonts/SCDream6.79b3247.woff";